import { commonApi, IPlatformItem } from '@/axios/common';
import { makeAutoObservable } from 'mobx';

class AppStore {
  constructor() {
    makeAutoObservable(this);
    this.init();
  }
  platformList: IPlatformItem[] = [];
  async init() {
    // 初始化应用级别的数据
    commonApi.getPlatformList().then((data) => {
      this.platformList = data;
    });
  }
}
export default new AppStore();
